/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiVehicleType, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of VehicleTypesController.
 */
export class VehicleTypesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /vehicle_types:prefill
     */
    public createPrefilled(): Promise<Result<ApiVehicleType>> {
        return this.http.post<Result<ApiVehicleType>, undefined>('/vehicle_types:prefill', undefined);
    }

    /**
     * Calls GET /vehicle_types:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiVehicleType>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiVehicleType>>>('/vehicle_types:query', query);
    }

    /**
     * Calls POST /vehicle_types:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiVehicleType>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiVehicleType>>, ListRequest>('/vehicle_types:query', listRequest, query);
    }

    /**
     * Calls POST /vehicle_types/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiVehicleType>>> {
        return this.http.post<Result<LockedContextDto<ApiVehicleType>>, undefined>(`/vehicle_types/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /vehicle_types/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiVehicleType>> {
        return this.http.post<Result<ApiVehicleType>, undefined>(`/vehicle_types/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /vehicle_types/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiVehicleType[]>> {
        return this.http.post<Result<ApiVehicleType[]>, string[]>('/vehicle_types/locks', ids);
    }

    /**
     * Calls POST /vehicle_types/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/vehicle_types/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /vehicle_types/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/vehicle_types/${primaryId}/locks`);
    }

    /**
     * Calls GET /vehicle_types/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiVehicleType>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiVehicleType>>(`/vehicle_types/${primaryId}`, query);
    }

    /**
     * Calls POST /vehicle_types
     */
    public add(dto: ApiVehicleType): Promise<Result<ApiVehicleType>> {
        return this.http.post<Result<ApiVehicleType>, ApiVehicleType>('/vehicle_types', dto);
    }

    /**
     * Calls PUT /vehicle_types/{primaryId}
     */
    public update(dto: ApiVehicleType, primaryId: string): Promise<Result<ApiVehicleType>> {
        return this.http.put<Result<ApiVehicleType>, ApiVehicleType>(`/vehicle_types/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /vehicle_types
     */
    public putRange(dtos: ApiVehicleType[]): Promise<Result<ApiVehicleType[]>> {
        return this.http.patch<Result<ApiVehicleType[]>, ApiVehicleType[]>('/vehicle_types', dtos);
    }

    /**
     * Calls DELETE /vehicle_types/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/vehicle_types/${primaryId}`);
    }

    /**
     * Calls POST /vehicletypes:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiVehicleType>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiVehicleType>>, ListRequestWithIds>('/vehicletypes:batch', listRequest, query);
    }
}
